import React, { ReactNode } from 'react'
import { addDays, isAfter, isBefore, subDays } from 'date-fns'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'

export function ShareSplitRow({ issue }: { issue: IssueEntity }) {
    let shareSplitContent: ReactNode = null
    const publicationDate = issue.publicationDate ? new Date(issue.publicationDate) : null

    if (issue.shareSplits.length === 0 || !publicationDate) {
        return null
    }

    const outcomePm = issue.sources.find((source) => source.sourceType === 'Outcome')
    const endComparisonDateBase = outcomePm ? new Date(outcomePm.publishedDate) : publicationDate
    const startComparisonDate = subDays(publicationDate, 30)
    const endComparisonDate = addDays(endComparisonDateBase, 30)

    const shareSplitWithinTimeFrame = issue.shareSplits.find(
        (shareSplit) =>
            isAfter(new Date(shareSplit.changeDate), startComparisonDate) &&
            isBefore(new Date(shareSplit.changeDate), endComparisonDate),
    )

    if (shareSplitWithinTimeFrame) {
        const { changeDate, newShares, oldShares } = shareSplitWithinTimeFrame
        const oldSharesLabel = oldShares > 1 ? 'aktier' : 'aktie'
        const newSharesLabel = newShares > 1 ? 'aktier' : 'aktie'

        if (newShares > oldShares) {
            shareSplitContent = `Aktiesplit den ${changeDate} där ${oldShares} ${oldSharesLabel} omvandlas till ${newShares} ${newSharesLabel}`
        } else if (oldShares > newShares) {
            shareSplitContent = `Sammanläggning av aktier den ${changeDate} där ${oldShares} ${oldSharesLabel} sammanläggs till ${newShares} ${newSharesLabel}`
        }
    }

    return shareSplitContent ? <FactsTableRow label='Aktiesplit'>{shareSplitContent}</FactsTableRow> : null
}
